import { request } from "../../../../services/api.ts"
import type { FormFieldRequirementsPayload } from "./form-field-requirements.types.ts"

const BASE_URL = "/crm/form-field-requirements/"

export const getFormFieldRequirements = (entity: string) =>
  request.api.get<FormFieldRequirementsPayload>(BASE_URL, { entity })

export const saveFormFieldRequirementsContext = (
  entity: string,
  context: string,
  all: string[],
  any_one: string[]
) =>
  request.api.put<{
    details: { message?: string; data: FormFieldRequirementsPayload }
  }>(BASE_URL, { entity, context, all, any_one })
